/** * * Asynchronously loads the component for
Insight Overview
* */ import { lazyLoad } from "utils/loadable";
export const InsightOverview = lazyLoad(
  () => import("./index"),
  (module) => module.InsightOverview
);